import React from 'react';
import styled from '@emotion/styled';
import { colors } from '../theme/tokens';
import { TitleLarge, SubtitleMedium } from '../components/Typography';

const DashboardContainer = styled.div`
  background-color: ${colors.neutral.white};
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  width: 100%;
  box-sizing: border-box;
`;

const Header = styled.div`
  margin-bottom: 1rem;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
  width: 100%;
  box-sizing: border-box;
`;

const Card = styled.div`
  background-color: ${colors.neutral.offWhite};
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  width: 100%;
  box-sizing: border-box;
`;

const Dashboard: React.FC = () => {
  return (
    <DashboardContainer>
      <Header>
        <TitleLarge>Dashboard</TitleLarge>
        <SubtitleMedium>Welcome to your admin console</SubtitleMedium>
      </Header>
      <Content>
        <Card>
          <h3>Quick Stats</h3>
          <p>Total Recipes: 24</p>
          <p>Active Users: 156</p>
        </Card>
        <Card>
          <h3>Recent Activity</h3>
          <p>New recipe added: Classic Margherita Pizza</p>
          <p>User registration: +5</p>
        </Card>
      </Content>
    </DashboardContainer>
  );
};

export default Dashboard; 